// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"0936c5c2","227":"51a65c64","315":"dbc74722","795":"b64cbb19","816":"2af5f50a","845":"47684eec","858":"44e14631","974":"16f757b0"}[chunkId] + ".chunk.js";
};